import { RefObject, useEffect } from 'react';

/** Publishes the element's height as a CSS variable on its parent, so sticky siblings can offset by it. */
export const usePublishedHeight = (
    ref: RefObject<HTMLElement | null>,
    cssVarName: string,
    enabled: boolean,
) => {
    useEffect(() => {
        const element = ref.current;
        if (!enabled || !element) return;
        const observer = new ResizeObserver(() =>
            element.parentElement?.style.setProperty(cssVarName, `${element.offsetHeight}px`),
        );
        observer.observe(element, { box: 'border-box' });
        return () => observer.disconnect();
    }, [ref, cssVarName, enabled]);
};
